import { safeProduce as produce } from "~helpers/immer";

import * as at from "./actionTypes";

export const initState = {
  filters: {},
  hideBlanks: false,
  sortInfos: {},
};

const figures = (state = initState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case at.SET_FIGURE_FILTER:
        for (const key in action.payload) {
          draft.filters[key] = action.payload[key];
        }
        break;
      case at.SET_HIDE_BLANKS:
        draft.hideBlanks = action.payload;
        break;
      case at.SET_FIGURE_SORT_INFO:
        for (const key in action.payload) {
          if (!draft.sortInfos[key]) {
            draft.sortInfos[key] = [];
          }
          draft.sortInfos[key] = action.payload[key];
        }
        break;
    }
  });

export default figures;
